<template>
  <v-list-item
    complex
    hover
    :isDisabledWithDropdown="isDisabled || disabled"
    clickable
    :selected="isSelected"
    @click.native="$emit('selectFile', file)"
    :identifier="file.uid"
  >
    <v-list-cell
      v-if="!hideCheckbox"
      withSelectAfterCallback
      :selected="isSelected"
      :hideCheckbox="isDisabled || disabled"
    ></v-list-cell>
    <v-list-cell class="relative thumbnail" style="flex: none !important" v-if="!isReady">
      <v-spinner slot="value" size="10" :loading="true" style="z-index: 1000"></v-spinner>
    </v-list-cell>
    <v-list-cell icon="Icon=folder.svg" v-if="!imageUrl && isReady" />
    <v-list-cell :thumbnail="imageUrl" v-if="isConverted && imageUrl" />
    <v-list-cell :title="file.title" size="4" :subtitle="$t('stati.files.text.' + currentStatus)" />
    <v-list-cell
      :size="listsSettings.libraryFiles.showAs.firstCol.size"
      :value="
        $h.formatValue(
          listsSettings.libraryFiles.showAs.firstCol.format,
          file[listsSettings.libraryFiles.showAs.firstCol.key],
          timezone
        )
      "
    />
    <v-list-cell
      v-if="!selectOnly"
      iconDropdown
      grey
      icon="Icon=more-horizontal.svg"
      iconColor="#5057af"
      :dropdownData="currentMoreDropdown"
      :dropdownUid="$h.createUniqueUid()"
      :dropdownValue="file.uid"
    />
  </v-list-item>
</template>

<script>
export default {
  name: "LibraryListItem",
  props: {
    file: {
      type: Object,
      default: function () {
        return {};
      },
    },
    team: {
      type: String,
      default: "",
    },
    currentFolder: {
      type: Object,
      default: function () {
        return {};
      },
    },
    timezone: {
      type: String,
      default: "",
    },
    statiBits: {
      type: Object,
      default: function () {
        return {};
      },
    },
    listsSettings: {
      type: Object,
      default: function () {
        return {};
      },
    },
    moreDropdown: {
      type: Array,
      default: () => {
        return [];
      },
    },
    moreDropdownWithDisabled: {
      type: Array,
      default: () => {
        return [];
      },
    },
    getSelf: {
      type: Function,
      default: () => {},
    },
    getPreview: {
      type: Function,
      default: () => {},
    },
    selectOnly: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Array,
      default: () => {
        return [];
      },
    },
    whitelist: {
      type: Array,
      default: function () {
        return [];
      },
    },
    blacklist: {
      type: Array,
      default: function () {
        return [];
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hideCheckbox: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      item: {},
      amountTry: 10,
      timeWaitStart: 3000,
      timer: null,
      imageUrl: "",
    };
  },
  created() {
    this.item = this.file;
    this.untilReady();
  },
  destroyed() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
  methods: {
    isConvertedCalculate(item) {
      return this.statiBits ? this.$h.globalIsBitSet(item.status, this.statiBits.CONVERTED.bit) : false;
    },
    isReadyCalculate(item) {
      if (this.statiBits && item.status) {
        return (
          this.$h.globalCheckFileStatus(item.status, this.statiBits) !== "VIRUS_SCANNING" &&
          this.$h.globalCheckFileStatus(item.status, this.statiBits) !== "CONVERTING"
        );
      } else {
        return false;
      }
    },
    isDownloadableCalculate(item) {
      return this.statiBits && item
        ? this.$h.globalIsBitSet(item.status, this.statiBits.VIRUS_SCAN_RESULT_OK.bit) ||
            this.$h.globalIsBitSet(item.status, this.statiBits.VIRUS_SCAN_RESULT_NA.bit)
        : false;
    },
    getItemPreview() {
      const data = {
        team: this.team,
        folder: this.currentFolder.uid,
        file: this.item.uid,
        customLoading: true,
        params: {
          width: 40,
          height: 40,
        },
      };
      if (this.isConverted && this.item.preview.image) {
        this.getPreview(data).then((res) => {
          this.imageUrl = res;
        });
      } else {
        this.imageUrl = "";
      }
    },
    untilReady() {
      this.getItemPreview(this.item);
      const data = {
        file: this.file.uid,
        folder: this.currentFolder.uid,
        customLoading: true,
      };
      if (!this.isReady) {
        const vm = this;
        vm.timer = setTimeout(function () {
          vm.getSelf(data)
            .then((response) => {
              vm.item = response;
              vm.amountTry = vm.amountTry - 1;
              if (vm.amountTry <= 0) {
                vm.amountTry = 10;
                vm.timeWaitStart = vm.timeWaitStart + 60000;
              }
              vm.untilReady();
            })
            .catch();
        }, vm.timeWaitStart);
      }
    },
  },
  computed: {
    isSelected() {
      return (
        this.selected.indexOf(this.item.uid) > -1 &&
        !(this.blacklist.indexOf(this.item.display_type) >= 0) &&
        (!this.whitelist.length || this.whitelist.indexOf(this.item.display_type) >= 0)
      );
    },
    isConverted() {
      return this.isConvertedCalculate(this.item);
    },
    isReady() {
      return this.isReadyCalculate(this.item);
    },
    isDisabled() {
      return this.isBlackListed || !this.isDownloadable;
    },
    isBlackListed() {
      return (
        this.blacklist.indexOf(this.item.display_type) >= 0 ||
        (this.whitelist.length > 0 ? this.whitelist.indexOf(this.item.display_type) < 0 : false)
      );
    },
    isDownloadable() {
      return this.isDownloadableCalculate(this.item);
    },
    currentStatus() {
      return this.statiBits && this.item ? this.$h.globalGetCurrentFileStatus(this.item.status, this.statiBits) : "";
    },
    currentMoreDropdown() {
      if (this.isDownloadable) {
        return this.moreDropdown;
      } else {
        return this.moreDropdownWithDisabled;
      }
    },
  },
};
</script>
